import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/kshAdmin/Template/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/kshAdmin/Template/create",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/kshAdmin/Template/edit",{
        params: {id:params}
    } )
}
  function SUBMIT_ADD(params) {
      return  axios.post("/kshAdmin/Template/createPost",{...params} )
  }
function SUBMIT_EDIT(params) {
    return  axios.post("/kshAdmin/Template/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/kshAdmin/Template/proxyEdit",{proxy:params} )
}
function EXPORT(params) {
    return  axios.get("/kshAdmin/Template/exportHtml",{
        params: {
      ...params
        }
    } )
}

function CHANG_STATUS_PROXY(params) {
    return  axios.post("/kshAdmin/Template/popupEdit",{popup:params} )
}
function ORDER_LIST (params) {
    return  axios.post("/kshAdmin/Template/listOrder",{list_orders:params} )
}function UPDATE_CACHE (params) {
    return  axios.post("/kshAdmin/Template/updateCache",{...params} )
}

function  TEMPLATE_DELETE(params) {
    return  axios.post("/kshAdmin/Template/delete",{ ids: params})
}
function  TEMPLATE_SELECT_CUSTOMER(params) {
    return  axios.get("/customer/ACustomer/templateSelectCustomer",{ params: params})
}
function  SELECT_TEMPLATE(params) {
    return  axios.post("/kshAdmin/Template/selectTemplate",{ ...params})
}

export default {UPDATE_CACHE,
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
     SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    EXPORT,
    CHANG_STATUS_PROXY,
    ORDER_LIST,
    TEMPLATE_SELECT_CUSTOMER,
    SELECT_TEMPLATE,
    TEMPLATE_DELETE
}
